import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router";
import { parseExperimentSearch } from "@charphq/ui/lib/experiments";
import { ExperimentRoutePage } from "../lib/ExperimentRoutePage";

/**
 * Code-split automatically: `vite.config.ts` runs
 * `tanstackRouter({ autoCodeSplitting: true })`, so this component leaves the
 * main bundle without needing `createLazyFileRoute`.
 *
 * `SearchSchemaInput` marks the *input* as partial while the output stays
 * complete, so a link into this route does not have to spell out every param.
 */
export const Route = createFileRoute("/experiments/comfort-streams")({
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    parseExperimentSearch(search),
  component: RouteComponent,
});

function RouteComponent() {
  return <ExperimentRoutePage slug="comfort-streams" search={Route.useSearch()} />;
}
